<!--
 * @developerName: 邓科峰
 * @Function name:
 * @Date: 2025-12-05 10:12:28
 * @param:
 * @LastEditor:
 * @LastData:
 * @Describe:
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 建议在 App.vue 中完善以下样式 */
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh; /* 使用视口高度确保全屏 */
  width: 100vw;  /* 确保全宽 */
  background-color: #f5f5f5;
  margin: 0;     /* 清除默认边距 */
  padding: 0;    /* 清除默认内边距 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue